// Copyright (c) 2022 Deere & Company

import * as actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateModalVisibility = (state, action) => action.visibility;

export default (state = getDefaultState().isPercentageDebitModalVisible, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_PERCENTAGE_DEBIT_MODAL_VISIBILITY]: updateModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/reducers/percentage-debit-modal.js